export default {
	title: 'safety',
	components: [
		{ title: 'max_power_protection', component: 'max_power_protection_g2' },
		{ title: 'max_voltage_protection', component: 'max_voltage_protection_g2' },
		{ title: 'max_current_protection', component: 'max_current_protection_g2' },
	],
};
